import React, { useState, useEffect, useMemo, useCallback } from 'react'
import useRouter from 'utils/useRouter'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import constants from 'utils/constants'
import { CircularProgress, Grid, Button, Typography, MenuItem, ButtonGroup, ListItemIcon, ListItemText, colors, Divider, Tooltip, useTheme } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import AdjustIcon from '@material-ui/icons/Adjust'
import HowToRegIcon from '@material-ui/icons/HowToReg'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import SendIcon from '@material-ui/icons/Send'
import NotInterestedIcon from '@material-ui/icons/NotInterested'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import AddIcon from '@material-ui/icons/Add'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import AddCommentIcon from '@material-ui/icons/AddComment'
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn'
import ExploreOffIcon from '@material-ui/icons/ExploreOff'
import CommentIcon from '@material-ui/icons/Comment'
import NextWeekIcon from '@material-ui/icons/NextWeek'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import ArchiveIcon from '@material-ui/icons/Archive'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import UnarchiveIcon from '@material-ui/icons/Unarchive'
import PhotoIcon from '@material-ui/icons/Photo'
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import InfoIcon from '@material-ui/icons/Info'
import { ModalGerenciarAcesso } from 'components/ModalGerenciarAcesso'
import { useCestaOperacaoLote } from 'hooks/useCestaOperacaoLote'
import { useAuth } from 'hooks/useAuth'

import PrintIcon from '@material-ui/icons/Print'
import { ModalImpressao } from 'components/ModalImpressao'
import { CustomButton } from 'components'
import { useVestigioService } from 'hooks/useVestigioService'
import { ModalPassagemVestigio, ModalContraprova, ModalRetirar } from './components'
import useStyles, { StyledMenu, StyledMenuItem } from './styles'

export const MenuAcoes = (props) => {
  const { vestigio, fetchDados, setProcessando, ultimaOperacao, apenasMenu, apenasCustodia } = props
  const vestigioService = useVestigioService()
  const classes = useStyles()
  const theme = useTheme()

  const { setReloadSelecionados, addVestigio, verificarItemEmCesta, removerVestigio } = useCestaOperacaoLote()
  const [textoObservacao, setTextoObservacao] = useState('')
  const [isDialogPassagemVestigioOpen, setIsDialogPassagemVestigioOpen] = useState(false)
  const [operacaoPassagemVestigio, setOperacaoPassagemVestigio] = useState(null)
  const router = useRouter()
  const [anchorEl, setAnchorEl] = useState(null)
  const { currentUser, verificarPermissao } = useAuth()
  const usuario = currentUser
  const [disableButton, setDisableButton] = useState(false)
  const [isRetirarOpen, setIsRetirarOpen] = useState(false)
  const [isTornarContraprovaOpen, setIsTornarContraprovaOpen] = useState(false)
  const [isGerenciarAcessoOpen, setIsGerenciarAcessoOpen] = useState(false)
  const [isModalImpressaoAberto, setIsModalImpressaoAberto] = useState(false)

  const [isUsuarioDestinoPassagemCustodia, setIsUsuarioDestinoPassagemCustodia] = useState(false)
  const [isUsuarioOrigemPassagemCustodia, setIsUsuarioOrigemPassagemCustodia] = useState(false)

  // Otimização: Substituído useLayoutEffect com 3 states por useMemo (Clean Code e Performance)
  const isSetorAtualVestigioIgualUsuario = useMemo(() => {
    if (!usuario?.setores || !vestigio?.setAtual) return false
    return usuario.setores.some((setor) => setor.id === vestigio.setAtual.id)
  }, [usuario?.setores, vestigio?.setAtual])

  const isSetorDestinoVestigioIgualUsuario = useMemo(() => {
    if (!usuario?.setores || !vestigio?.setDest) return false
    return usuario.setores.some((setor) => setor.id === vestigio.setDest.id)
  }, [usuario?.setores, vestigio?.setDest])

  // Otimização: Mudado de useLayoutEffect para useEffect e tratado de forma segura
  useEffect(() => {
    const verificarUsuarioOrigemEDestinoPassagemCustodia = async () => {
      if (!vestigio?.id || !currentUser?.id) return

      try {
        const ultimaPassagemCustodia = await vestigioService.listarUltimaPassagemCustodia(vestigio.id)
        if (vestigio.statusCadeiaCustodia === 'ENCAMINHADO') {
          const ultimoEncaminhamento = await vestigioService.listarUltimoEncaminhamento(vestigio.id)
          setTextoObservacao(ultimoEncaminhamento?.acao.observacao || '')
        } else {
          setTextoObservacao(ultimaPassagemCustodia?.acao.observacao || '')
        }

        setIsUsuarioDestinoPassagemCustodia(ultimaPassagemCustodia?.id_usuario_destino === currentUser.id)
        setIsUsuarioOrigemPassagemCustodia(ultimaPassagemCustodia?.id_usuario_origem === currentUser.id)
      } catch (error) {
        console.error('Erro ao verificar passagem de custódia:', error)
      }
    }

    verificarUsuarioOrigemEDestinoPassagemCustodia()
  }, [vestigio?.id, vestigio?.statusCadeiaCustodia, currentUser?.id])

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClickBotaoCesta = (event) => {
    if (verificarItemEmCesta(vestigio.id)) {
      removerVestigio(vestigio.id)
    } else {
      addVestigio(vestigio)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuBotaoAcoes = (to) => {
    router.history.push(to)
  }

  const handleAceitarVestigio = async () => {
    setDisableButton(true)
    await vestigioService.aceitarVestigio(vestigio.id)
    setReloadSelecionados(true)
    setDisableButton(false)
    fetchDados()
  }

  const handleNegarVestigio = async () => {
    setDisableButton(true)
    await vestigioService.negarVestigio(vestigio.id)
    setReloadSelecionados(true)
    setDisableButton(false)
    fetchDados()
  }

  const closeDialogPassagemVestigio = async () => {
    setOperacaoPassagemVestigio(null)
    setIsDialogPassagemVestigioOpen(false)
  }
  const handleNegarPassagemCustodia = async () => {
    setOperacaoPassagemVestigio('NEGAR')
    setIsDialogPassagemVestigioOpen(true)
  }

  const handleAceitarPassagemCustodia = async () => {
    setOperacaoPassagemVestigio('ACEITAR')
    setIsDialogPassagemVestigioOpen(true)
  }

  const handleCancelarPassagemCustodia = async () => {
    setOperacaoPassagemVestigio('CANCELAR')
    setIsDialogPassagemVestigioOpen(true)
  }

  const handleAbrirModalImpressao = () => {
    setAnchorEl(null)
    setIsModalImpressaoAberto(true)
  }

  const handleConfirmacaoDialogPassagemVestigio = async () => {
    switch (operacaoPassagemVestigio) {
      case 'NEGAR': {
        await vestigioService.negarPassagemCustodia(vestigio.id, setProcessando)
        break
      }
      case 'ACEITAR': {
        await vestigioService.aceitarPassagemCustodia(vestigio.id, setProcessando)
        break
      }
      case 'CANCELAR': {
        await vestigioService.cancelarPassagemCustodia(vestigio.id, setProcessando)
        break
      }
      default: {
        break
      }
    }
    fetchDados()
    setReloadSelecionados(true)
    closeDialogPassagemVestigio()
  }


  const openDialogRetirar = () => {
    setIsRetirarOpen(true)
  }

  const handleClickRetirarVestigio = () => {
    openDialogRetirar()
  }

  const closeDialogRetirar = () => {
    setIsRetirarOpen(false)
  }

  const handleRetirarVestigio = async () => {
    await vestigioService.retirarVestigio(vestigio.id, setProcessando)
    fetchDados()
    setReloadSelecionados(true)
    closeDialogRetirar()
  }

  const openDialogContraprova = () => {
    setIsTornarContraprovaOpen(true)
  }

  const handleClickBotaoTornarContraprova = async () => {
    openDialogContraprova()
  }

  const closeDialogContraprova = () => {
    setIsTornarContraprovaOpen(false)
  }

  const handleTornarContraprova = async () => {
    await vestigioService.tornarContraprova(vestigio.id, setProcessando)
    fetchDados()
    setReloadSelecionados(true)
    closeDialogContraprova()
  }

  const handleClickAdicionarInformacao = useCallback(() => {
    router.history.push(`/vestigio/adicionarInformacao/${vestigio.id}`)
  }, [])

  const handleClickGerarTermoNaoConformidade = useCallback(() => {
    router.history.push(`/vestigio/gerarTermoNaoConformidade/${vestigio.id}`)
  }, [])

  const renderizarTudo = !apenasMenu && !apenasCustodia

  if (apenasCustodia) {
    const temAcoes = (vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorDestinoVestigioIgualUsuario) ||
      (isUsuarioDestinoPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA') ||
      (isUsuarioOrigemPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA') ||
      (vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorAtualVestigioIgualUsuario)

    const exibirObs = textoObservacao && (
      (vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorDestinoVestigioIgualUsuario) ||
      (isUsuarioDestinoPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA')
    )

    if (!temAcoes && !exibirObs) return null

    let tituloBanner = ""
    let descricaoBanner = ""
    let tipoAlerta = "info" // "info" ou "warning"

    if (vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorDestinoVestigioIgualUsuario) {
      tituloBanner = "Recebimento de Vestígio Pendente"
      descricaoBanner = "Este vestígio foi encaminhado para o seu setor e aguarda a sua aceitação ou recusa."
      tipoAlerta = "warning"
    } else if (isUsuarioDestinoPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA') {
      tituloBanner = "Passagem de Custódia Pendente"
      descricaoBanner = "Uma solicitação de passagem de custódia direta deste vestígio foi enviada para você e aguarda sua aceitação ou recusa."
      tipoAlerta = "warning"
    } else if (isUsuarioOrigemPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA') {
      tituloBanner = "Aguardando Aceite da Passagem de Custódia"
      descricaoBanner = "Você transferiu a custódia deste vestígio e está aguardando que o usuário de destino aceite o recebimento."
      tipoAlerta = "info"
    } else if (vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorAtualVestigioIgualUsuario) {
      tituloBanner = "Aguardando Recebimento pelo Setor de Destino"
      descricaoBanner = "Este vestígio foi encaminhado para outro setor. Aguardando a aceitação do setor destinatário."
      tipoAlerta = "info"
    }

    return (
      <div className={clsx(classes.custodiaAlert, {
        [classes.custodiaAlertWarning]: tipoAlerta === 'warning',
        [classes.custodiaAlertInfo]: tipoAlerta === 'info'
      })}>
        {/* Contêiner Superior: Conteúdo principal (ícone + textos) e botões de ação */}
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
          <div className={classes.custodiaAlertContent}>
            {tipoAlerta === 'warning' ? (
              <ReportProblemIcon className={classes.custodiaAlertIconWarning} />
            ) : (
              <InfoIcon className={classes.custodiaAlertIconInfo} />
            )}
            <div className={classes.custodiaAlertTexts}>
              <Typography className={classes.custodiaAlertTitle}>
                {tituloBanner}
              </Typography>
              <Typography className={classes.custodiaAlertDescription}>
                {descricaoBanner}
              </Typography>
            </div>
          </div>

          {temAcoes && (
            <div className={classes.custodiaAlertActions}>
              {vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorDestinoVestigioIgualUsuario && (
                <>
                  <CustomButton
                    colorType="error"
                    startIcon={<NotInterestedIcon />}
                    onClick={handleNegarVestigio}
                    isLoading={disableButton}
                  >
                    Negar
                  </CustomButton>
                  <CustomButton
                    colorType="success"
                    startIcon={<DoneOutlineIcon />}
                    onClick={handleAceitarVestigio}
                    isLoading={disableButton}
                  >
                    Aceitar
                  </CustomButton>
                </>
              )}
              {isUsuarioDestinoPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA' && (
                <>
                  <CustomButton
                    colorType="error"
                    startIcon={<NotInterestedIcon />}
                    onClick={handleNegarPassagemCustodia}
                    isLoading={disableButton}
                  >
                    Negar
                  </CustomButton>
                  <CustomButton
                    colorType="success"
                    startIcon={<DoneOutlineIcon />}
                    onClick={handleAceitarPassagemCustodia}
                    isLoading={disableButton}
                  >
                    Aceitar
                  </CustomButton>
                </>
              )}
              {isUsuarioOrigemPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA' && (
                <CustomButton
                  colorType="warning"
                  startIcon={<NotInterestedIcon />}
                  onClick={handleCancelarPassagemCustodia}
                  isLoading={disableButton}
                >
                  Cancelar
                </CustomButton>
              )}
              {vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorAtualVestigioIgualUsuario && (
                <Link
                  to={{
                    pathname: `/centraldecustodia/vestigio/cancelarencaminhamento/${vestigio.id}`,
                  }}
                  style={{ textDecoration: 'none' }}
                >
                  <CustomButton
                    colorType="warning"
                    startIcon={<NotInterestedIcon />}
                  >
                    Cancelar
                  </CustomButton>
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Contêiner Inferior: Observações (alinhadas verticalmente com o título de cima) */}
        {exibirObs && (
          <div style={{ width: '100%', paddingLeft: '48px', boxSizing: 'border-box' }}>
            <div className={classes.custodiaAlertObs}>
              Observação: {textoObservacao}
            </div>
          </div>
        )}

        <ModalPassagemVestigio
          aberto={isDialogPassagemVestigioOpen}
          onClose={closeDialogPassagemVestigio}
          onConfirm={handleConfirmacaoDialogPassagemVestigio}
          processando={disableButton}
          operacao={operacaoPassagemVestigio}
        />
      </div>
    )
  }

  // Se for apenas o menu suspenso de ações no topo
  return (
    <Grid alignItems="center" justifyContent="flex-end" container spacing={1}>
      {renderizarTudo && vestigio.statusCadeiaCustodia === 'DESCARTADO' && (
        <Grid item>
          <CustomButton colorType="error" startIcon={<NotInterestedIcon />} disabled>
            Vestígio descartado
          </CustomButton>
        </Grid>
      )}

      {renderizarTudo && vestigio.statusCadeiaCustodia === 'ENCAMINHADO' && isSetorDestinoVestigioIgualUsuario && (
        <Grid item>
          <CustomButton
            colorType="error"
            startIcon={<NotInterestedIcon />}
            onClick={handleNegarVestigio}
            isLoading={disableButton}
          >
            Negar Vestígio
          </CustomButton>
          <CustomButton
            colorType="success"
            startIcon={<DoneOutlineIcon />}
            onClick={handleAceitarVestigio}
            isLoading={disableButton}
            style={{ marginLeft: 8 }}
          >
            Aceitar Vestígio
          </CustomButton>
        </Grid>
      )}

      {renderizarTudo && isUsuarioDestinoPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA' && (
        <Grid item>
          <CustomButton
            colorType="error"
            startIcon={<NotInterestedIcon />}
            onClick={handleNegarPassagemCustodia}
            isLoading={disableButton}
          >
            Negar Passagem de custódia
          </CustomButton>
          <CustomButton
            colorType="success"
            startIcon={<DoneOutlineIcon />}
            onClick={handleAceitarPassagemCustodia}
            isLoading={disableButton}
            style={{ marginLeft: 8 }}
          >
            Aceitar Passagem de custódia
          </CustomButton>
        </Grid>
      )}

      {renderizarTudo && isUsuarioOrigemPassagemCustodia && vestigio.statusCadeiaCustodia === 'EM_PASSAGEM_CUSTODIA' && (
        <Grid item>
          <CustomButton
            colorType="warning"
            startIcon={<NotInterestedIcon />}
            onClick={handleCancelarPassagemCustodia}
            isLoading={disableButton}
          >
            Cancelar passagem de custódia
          </CustomButton>
        </Grid>
      )}

      {renderizarTudo && (
        <ModalPassagemVestigio
          aberto={isDialogPassagemVestigioOpen}
          onClose={closeDialogPassagemVestigio}
          onConfirm={handleConfirmacaoDialogPassagemVestigio}
          processando={disableButton}
          operacao={operacaoPassagemVestigio}
        />
      )}

      {!(vestigio.vesFils && vestigio.vesFils.length) && (
        <Grid item>
          <ButtonGroup aria-controls="customized-menu" className={classes.actions} aria-haspopup="true" variant="contained" color="primary">
            <Tooltip title={verificarItemEmCesta(vestigio.id) ? 'Remover da cesta' : 'Adicionar à cesta'}>
              <Button variant="outlined" id="botao-adicionar-cesta" onClick={handleClickBotaoCesta}>
                {verificarItemEmCesta(vestigio.id) ? (
                  <RemoveCircleIcon />
                ) : (
                  <img
                    src="/images/cesta-add-black.png"
                    alt="Adicionar à cesta"
                    className="img-icon-invert-dark"
                    style={{
                      width: 24,
                      height: 24,
                    }}
                  />
                )}
              </Button>
            </Tooltip>
            <Button onClick={handleClickBotaoAcoes} endIcon={<ArrowDropDownIcon />}>
              Ações
            </Button>
          </ButtonGroup>

          <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            <>
              {verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO_ADMINISTRADOR]) && (
                <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/vestigios/vestigio/retornar/${vestigio.id}`)}>
                  <ListItemIcon>
                    <KeyboardReturnIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Retornar vestígio" />
                </StyledMenuItem>
              )}

              {vestigio.entregue && verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO]) && (
                <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/vestigios/vestigio/retornar/${vestigio.id}`)}>
                  <ListItemIcon>
                    <KeyboardReturnIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Retornar Vestígio" />
                </StyledMenuItem>
              )}

              <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/vestigios/vestigio/guardar/${vestigio.id}`)} disabled={!(vestigio.statusCadeiaCustodia === 'COM_USUARIO' && vestigio.id_usuario_atual === usuario.id) || !verificarPermissao([constants.PERMISSOES.GUARDAR_VESTIGIO])}>
                <ListItemIcon>
                  <ArchiveIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Guardar vestígio" />
              </StyledMenuItem>
              <StyledMenuItem onClick={() => handleClickRetirarVestigio()} disabled={!(vestigio.statusCadeiaCustodia === 'GUARDADO') || !isSetorAtualVestigioIgualUsuario}>
                <ListItemIcon>
                  <UnarchiveIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Retirar vestígio" />
              </StyledMenuItem>
              <StyledMenuItem
                onClick={() =>
                  vestigio.deExtracaoVestigio || vestigio.deExtracaoCadaver || vestigio.deExtracaoVeiculo || vestigio.deExtracaoPericiando
                    ? handleMenuBotaoAcoes(`/vestigios/vestigio/editar-de-extracao/${vestigio.id}`)
                    : handleMenuBotaoAcoes(`/casos/caso/vestigio/editar/${vestigio.id}/${vestigio.casos[0]?.id || 'NULL'}`)
                }
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Editar vestígio" />
              </StyledMenuItem>
              <StyledMenuItem onClick={() => handleClickBotaoTornarContraprova()} disabled={vestigio.contraprova || !vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario)}>
                <ListItemIcon>
                  <AdjustIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Tornar contraprova" />
              </StyledMenuItem>

              <ModalContraprova
                aberto={isTornarContraprovaOpen}
                onClose={closeDialogContraprova}
                onConfirm={handleTornarContraprova}
                identificador={vestigio.identificador}
              />

              <ModalRetirar
                aberto={isRetirarOpen}
                onClose={closeDialogRetirar}
                onConfirm={handleRetirarVestigio}
                identificador={vestigio.identificador}
              />

              <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/vestigios/vestigio/extrair/${vestigio.id}`)} disabled={!vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario) || !verificarPermissao([constants.PERMISSOES.CADASTRAR_VESTIGIO_POR_EXTRACAO])}>
                <ListItemIcon>
                  <AddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Extrair novo vestígio" />
              </StyledMenuItem>

              <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/vestigio/encaminharParaUsuario/${vestigio.id}`)} disabled={!vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario) || !verificarPermissao([constants.PERMISSOES.ENCAMINHAR_VESTIGIO])}>
                <ListItemIcon>
                  <HowToRegIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Encaminhar com confirmação" />
              </StyledMenuItem>

              <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/vestigio/encaminhar/${vestigio.id}`)} disabled={!vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario) || !verificarPermissao([constants.PERMISSOES.ENCAMINHAR_VESTIGIO])}>
                <ListItemIcon>
                  <SendIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Encaminhar para outro setor" />
              </StyledMenuItem>

              <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/vestigio/passarcustodia/${vestigio.id}`)} disabled={!vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario) || !verificarPermissao([constants.PERMISSOES.SOLICITAR_PASSAGEM_CUSTODIA])}>
                <ListItemIcon>
                  <NextWeekIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Passar custódia" />
              </StyledMenuItem>

              <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/vestigio/entregar/${vestigio.id}`)} disabled={!vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario) || !verificarPermissao([constants.PERMISSOES.ENTREGAR_VESTIGIO])}>
                <ListItemIcon>
                  <DoneAllIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Entregar ao destino final" />
              </StyledMenuItem>
            </>

            <StyledMenuItem onClick={handleClickAdicionarInformacao}>
              <ListItemIcon>
                <AddCommentIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Adicionar Informação</ListItemText>
            </StyledMenuItem>

            <StyledMenuItem onClick={handleClickGerarTermoNaoConformidade}>
              <ListItemIcon>
                <ReportProblemIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Gerar Termo de Não Conformidade" />
            </StyledMenuItem>

            <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/vestigios/vestigio/consumirvestigio/${vestigio.id}`)} disabled={!vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario)}>
              <ListItemIcon>
                <ExploreOffIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Consumir vestígio" />
            </StyledMenuItem>

            <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/centraldecustodia/vestigio/descartar/${vestigio.id}`)} disabled={!vestigioService.verificarVestigioEmCustodiaDeUsuario(vestigio, usuario) || !verificarPermissao([constants.PERMISSOES.DESCARTAR_VESTIGIO])}>
              <ListItemIcon>
                <DeleteForeverIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Descartar vestígio" />
            </StyledMenuItem>

            <StyledMenuItem onClick={handleAbrirModalImpressao}>
              <ListItemIcon>
                <PrintIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Imprimir Etiqueta" />
            </StyledMenuItem>

            <StyledMenuItem onClick={() => router.history.push(`/galeria/vestigio/${vestigio.id}`)}>
              <ListItemIcon>
                <PhotoIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Ver galeria" />
            </StyledMenuItem>

            {currentUser.cargo.id === 1 && (
              <StyledMenuItem onClick={() => setIsGerenciarAcessoOpen(true)}>
                <ListItemIcon>
                  <SupervisedUserCircleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Conceder acesso à galeria" />
              </StyledMenuItem>
            )}
          </StyledMenu>
        </Grid>
      )}

      <ModalGerenciarAcesso open={isGerenciarAcessoOpen} onClose={() => setIsGerenciarAcessoOpen(false)} idCaso={vestigio.casos && vestigio.casos.length > 0 ? vestigio.casos[0].id : null} usuarios={[]} selecionados={[]} />
      <ModalImpressao aberto={isModalImpressaoAberto} setAberto={setIsModalImpressaoAberto} titulo="INFORMAÇÕES DO VESTÍGIO" processando={false} vestigio={vestigio}></ModalImpressao>
    </Grid>
  )
}
